import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Icon } from "antd";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Link } from "react-router-dom";
import { Loading } from "../../../components/Loading";
import { IndexAvatar } from "../../../components";
import {
  getSystemMessage,
  clearSystemMessage,
  selectSystemMessage,
  getSystemMessageUnreadCount,
  setPromptChoice,
} from "../../../routes/SystemMessage/systemMessage.ducks";
import { SystemMessageType } from "../../../models/enums";
import { formatDate, getWindowWidth, isMobileScreen, notification, scrollToTop } from "../../../services";
import { getIconUrl } from "../../../services/asset";
import { PageRoute } from "../../../models";
import { TAB_PARAM, TAB_SYSTEM } from "../constants/constants";
import chatStyles from "../chatPage.scss";
import styles from "./systemMessages.scss";

const SystemMessageDetail = ({ messageId }) => {
  const dispatch = useDispatch();
  const message = useSelector(selectSystemMessage);
  const [submitting, setSubmitting] = useState(false);
  const [currentChoice, setCurrentChoice] = useState(null);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [imageSources, setImageSources] = useState([]);
  const contentRef = useRef(null);

  useEffect(function () {
    var el = contentRef.current;
    if (!el) return;

    var handleClick = function (e) {
      if (e.target.tagName === "IMG") {
        var images = el.querySelectorAll("img");
        var srcs = [];
        var clickedIdx = 0;
        for (var i = 0; i < images.length; i++) {
          srcs.push(images[i].src);
          if (images[i] === e.target) clickedIdx = i;
        }
        setImageSources(srcs);
        setPhotoIndex(clickedIdx);
        setLightboxOpen(true);
      }
    };

    el.addEventListener("click", handleClick);
    return function () {
      el.removeEventListener("click", handleClick);
    };
  }, [message]);

  const isMobile = isMobileScreen(getWindowWidth());
  const backUrl = `${PageRoute.chats}?${TAB_PARAM}=${TAB_SYSTEM}`;

  useEffect(() => {
    scrollToTop();
    if (messageId) {
      dispatch(getSystemMessage(messageId));
    }
    return () => {
      dispatch(clearSystemMessage());
      dispatch(getSystemMessageUnreadCount());
    };
  }, [messageId]);

  useEffect(() => {
    if (message) {
      setCurrentChoice(message.promptChoice !== undefined ? message.promptChoice : null);
    }
  }, [message]);

  const isPromptChoice = message && message.type === SystemMessageType.PromptChoice;

  const handlePromptChoice = (choice) => {
    if (currentChoice === choice) return;
    setSubmitting(true);
    dispatch(setPromptChoice(messageId, choice, (success) => {
      setSubmitting(false);
      if (success) {
        setCurrentChoice(choice);
        const label = choice ? (message.yesPromptChoiceLabel || "Da") : (message.noPromptChoiceLabel || "Ne");
        notification.show(`Odgovorili ste: ${label}`);
      } else {
        notification.showError("Greška pri slanju odgovora");
      }
    }));
  };

  return (
    <div className={chatStyles.singleChatWrapper}>
      <Card className={`${chatStyles.headerCard} ${styles.systemHeaderCard}`} bordered={false}>

        <React.Fragment>
          <div className={chatStyles.backRow}>
            <Link to={backUrl} className={chatStyles.backToMessagesLink}>
              <img className={chatStyles.backToMessagesChevron} alt="" src={getIconUrl("chevron-left.svg")} />
              <span className={chatStyles.backToMessages}>Natrag na poruke</span>
            </Link>
          </div>
          {message && (
            <div className={chatStyles.userRow}>
              <div className={chatStyles.userInfo}>
                <IndexAvatar size={60} className={chatStyles.avatar} />
                <div className={chatStyles.userDetails}>
                  <span className={chatStyles.username}>{message.senderName || "Index Oglasi"}</span>
                  <span className={styles.detailDate}>{formatDate(message.createdAt)}</span>
                </div>
              </div>
            </div>
          )}
        </React.Fragment>

      </Card>
      {message && (
        <Card bordered={false} className={styles.titleCard}>
          <p className={styles.titleText}>{message.title}</p>
        </Card>
      )}
      {!message ? (
        <Loading className={styles.loading} />
      ) : (
        <div
          ref={contentRef}
          className={styles.detailContentScroll}
          dangerouslySetInnerHTML={{ __html: message.content }}
        />
      )}
      {isPromptChoice && (
        <div className={styles.detailFooter}>
          <Button
            className={currentChoice === false ? styles.btnChoiceSelected : styles.btnChoice}
            onClick={() => handlePromptChoice(false)}
            loading={submitting}
          >
            {currentChoice === false && <Icon type="check" className={styles.checkIcon} />}
            {message.noPromptChoiceLabel || "Ne"}
          </Button>
          <Button
            className={styles.btnChoiceDa}
            onClick={() => handlePromptChoice(true)}
            loading={submitting}
          >
            {currentChoice === true && <Icon type="check" className={styles.checkIconWhite} />}
            {message.yesPromptChoiceLabel || "Da"}
          </Button>
        </div>
      )}
      {lightboxOpen && imageSources.length > 0 && (
        <Lightbox
          mainSrc={imageSources[photoIndex]}
          nextSrc={imageSources.length > 1 ? imageSources[(photoIndex + 1) % imageSources.length] : undefined}
          prevSrc={imageSources.length > 1 ? imageSources[(photoIndex + imageSources.length - 1) % imageSources.length] : undefined}
          onCloseRequest={function () { setLightboxOpen(false); }}
          onMovePrevRequest={function () { setPhotoIndex((photoIndex + imageSources.length - 1) % imageSources.length); }}
          onMoveNextRequest={function () { setPhotoIndex((photoIndex + 1) % imageSources.length); }}
          imageCaption={imageSources.length > 1 ? (photoIndex + 1) + " / " + imageSources.length : undefined}
          animationOnKeyInput
        />
      )}
    </div>
  );
};

export default SystemMessageDetail;



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SystemMessages/SystemMessageDetail.tsx